/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdatePlaceholderAllocationInput = {
    id?: string | null | undefined;
    startDate?: string | null | undefined;
    endDate?: string | null | undefined;
    placeholderId?: string | null | undefined;
    monday?: number | null | undefined;
    tuesday?: number | null | undefined;
    wednesday?: number | null | undefined;
    thursday?: number | null | undefined;
    friday?: number | null | undefined;
    saturday?: number | null | undefined;
    sunday?: number | null | undefined;
    description?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updatePlaceholderAllocationMutationVariables = {
    input: UpdatePlaceholderAllocationInput;
};
export type updatePlaceholderAllocationMutationResponse = {
    readonly updatePlaceholderAllocation: {
        readonly placeholderAllocation: {
            readonly node: {
                readonly id: string;
                readonly startDate: string | null;
                readonly endDate: string | null;
                readonly monday: number | null;
                readonly tuesday: number | null;
                readonly wednesday: number | null;
                readonly thursday: number | null;
                readonly friday: number | null;
                readonly saturday: number | null;
                readonly sunday: number | null;
                readonly description: string | null;
                readonly placeholder: {
                    readonly id: string;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type updatePlaceholderAllocationMutation = {
    readonly response: updatePlaceholderAllocationMutationResponse;
    readonly variables: updatePlaceholderAllocationMutationVariables;
};



/*
mutation updatePlaceholderAllocationMutation(
  $input: UpdatePlaceholderAllocationInput!
) {
  updatePlaceholderAllocation(input: $input) {
    placeholderAllocation {
      node {
        id
        startDate
        endDate
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        description
        placeholder {
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePlaceholderAllocationInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdatePlaceholderAllocationPayload",
    "kind": "LinkedField",
    "name": "updatePlaceholderAllocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlaceholderAllocationTypeEdge",
        "kind": "LinkedField",
        "name": "placeholderAllocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PlaceholderAllocation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tuesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wednesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thursday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "friday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "saturday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sunday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Placeholder",
                "kind": "LinkedField",
                "name": "placeholder",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePlaceholderAllocationMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePlaceholderAllocationMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updatePlaceholderAllocationMutation",
    "operationKind": "mutation",
    "text": "mutation updatePlaceholderAllocationMutation(\n  $input: UpdatePlaceholderAllocationInput!\n) {\n  updatePlaceholderAllocation(input: $input) {\n    placeholderAllocation {\n      node {\n        id\n        startDate\n        endDate\n        monday\n        tuesday\n        wednesday\n        thursday\n        friday\n        saturday\n        sunday\n        description\n        placeholder {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '750a908fef1c33d675a0233ee83facce';
export default node;
